export enum TrackingEvent {
  BulkDelete = `[Users] Bulk Delete`,
  FilterTable = `[Users] Filter Table`,
  UpdateColumns = `[Users] Update Columns`,
  UnselectAll = `[Users] Unselect All`,
  CreateOrUpdateProfile = `[Users] Create or Update Profile`,
  ToggleQueryBuilder = `[Users] Toggle Query Builder`,
  SavedCohort = `[Users] Saved Cohort`,
  ClearedFilters = `[Users] Cleared Filters`,
  ExportClicked = `[Users] Export clicked`,
  ExportClickedOnSavedCohort = `[Cohorts] Export clicked`,
  DataGroupSelected = `[Users] Data Group Selected`,
  ProfileClicked = `[Users] Profile Clicked`,
  ViewUsersPage = `[Users] View Users Page`,
}

export enum TrackingEventProperty {
  AllItemsCount = `All items count`,
  SelectedCount = `Selected count`,
  DeletedCount = `Deleted count`,
  VisibleCount = `Visible count`,
  FilterName = `Filter name`,
  FilterValue = `Filter value`,
  ColumnsSelectedCount = `Columns selected count`,
  NewColumns = `New column selection`,
  UnselectedItemsCount = `Unselected items count`,
  PreviousColumnSelection = `Previous column selection`,
  MessageSelectedCount = `Message selected count`,
  MessageType = `Message type`,
  ShowingFilters = `Showing filters`,
  IntegrationName = `Integration Name`,
  CohortUserCount = `cohort user count`,
  IsCompanyProfileDataGroup = `Is Company Profile Data Group`,
  DataGroupId = `Data Group Id`,
  DistinctId = `Distinct Id`,
  HasCompanyProfileDataGroupConfigured = `Has Company Profile Data Group Configured`,
}

export enum TrackingPeopleProperty {
  HasNewUsersExperience = `Has New Users Experience`,
}

type TrackingEventProperties = {
  [key in TrackingEventProperty]?: any;
};
export function track(event: TrackingEvent, properties: TrackingEventProperties = {}) {
  mixpanel.track(event, properties);
}
